import type {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {ActionButton} from 'components/PageHeader';
import {LD_FLAGS, useFeatureFlag} from 'modules/feature-flags';

export const AddResourceButton: FC = () => {
  const navigate = useNavigate();
  const canManageResources = useFeatureFlag(LD_FLAGS.RESOURCE_ADMIN);

  console.log('Can manage resources:', canManageResources);

  if (!canManageResources) {
    return null;
  }

  return (
    <ActionButton
      onClick={() => navigate('/resources/new')}
      label="Add Resource"
      testId="add-resource-button"
    />
  );
};
